import React from "react";
import { Link } from "react-router-dom";
import { PlaceHolderImages } from "../../../lib/placeholder-images";
import Header from "../../common/header";
import { TopExperiences } from "../../../components/top-experiences";
import { Testimonials } from "../../../components/testimonials";
import Footer from "../../common/footer";
import { PartnerLogos } from "../../../components/partner-logos";
import { VisaServiceCard } from "../../../components/visa-service-card";
import { VisaTrackerForm } from "../../../components/visa-tracker-form";
import { Badge } from "../../../components/ui/badge";
import KsaTopExperiences from "../../../components/ksa-top-experiences";
import CategoryList from "../../Categories/CategoryList";
import { VisaCalculator } from "../../../components/visa-calculator";
import { CheckoutPageAnimator } from "../../../components/checkout-page-animator";
import { FloatingButtons } from "../../../components/floating-buttons";

export default function Home() {
  const heroImage = PlaceHolderImages.find((p) => p.id === "hero-travel");
  const uaeVisaImage = PlaceHolderImages.find((p) => p.id === "uae-visa");
  const ksaVisaImage = PlaceHolderImages.find((p) => p.id === "ksa-visa");
  const resortsImage = PlaceHolderImages.find((p) => p.id === "resorts");
  const pickAndDropImage = PlaceHolderImages.find(
    (p) => p.id === "pick-and-drop"
  );

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <CheckoutPageAnimator />
      <Header />
      
            <FloatingButtons/>
      <main className="flex-grow">
        {/* ✅ HERO SECTION */}
        <section
          id="home"
          className="relative text-center pt-32 pb-20 md:py-32 overflow-hidden"
        >
          {heroImage && (
            <img
              src={heroImage.imageUrl}
              alt={heroImage.description}
              className="absolute inset-0 w-full h-full object-cover object-center brightness-[0.6]"
            />
          )}
          <div className="container mx-auto px-4 relative z-10 flex flex-col items-center">
            <Badge
              variant="secondary"
              className="bg-primary text-primary-foreground hover:bg-primary/90 py-2 px-4 rounded-full text-sm font-semibold mb-4"
            >
              GET YOUR VISA IN JUST 2 EASY STEPS
            </Badge>
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-white">
              Apply in minutes.
            </h1>
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-white mt-2">
              Get approved in hours.
            </h1>
            <div className="mt-8 w-full max-w-lg">
              <VisaTrackerForm />
            </div>
          </div>
        </section>

        {/* ✅ VISA SERVICES SECTION */}
        <CategoryList />

        {/* ✅ VISA CALCULATOR */}
        {/* <section
          id="calculator"
          className="pt-8 pb-16 bg-background"
        >
          <div className="container mx-auto px-4 max-w-7xl">
            <VisaCalculator />
          </div>
        </section> */}

        {/* ✅ PARTNER LOGOS */}
        <section id="partners" className="py-8 bg-background">
          <div className="container mx-auto px-4 max-w-7xl">
            <PartnerLogos />
          </div>
        </section>

        {/* ✅ PROMO VIDEO */}
        <section id="video-promo" className="py-16 bg-white">
          <div className="custom-container mx-auto px-4 max-w-4xl">
            <div className="aspect-video w-full mx-auto rounded-lg overflow-hidden shadow-2xl pointer-events-none">
              <iframe
                src="https://www.youtube.com/embed/CXDuqZ9RZXk?start=3&end=30&autoplay=1&mute=1&loop=1&playlist=CXDuqZ9RZXk&controls=0&playsinline=1&showinfo=0&modestbranding=1&rel=0"
                title="Promo Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </section>

        {/* ✅ EXPERIENCES */}
        <section id="experiences" className="py-16 bg-gray-50">
          <TopExperiences />
        </section>

        {/* ✅ KSA EXPERIENCES */}
        <section id="ksa-experiences" className="py-16 bg-gray-50">
          <KsaTopExperiences />
        </section>

        {/* ✅ TESTIMONIALS */}
        <section id="testimonials">
          <Testimonials />
        </section>
      </main>

      <Footer />
    </div>
  );
}
